/* eslint no-underscore-dangle: 0 */
/* eslint camelcase: 0 */
/* eslint no-param-reassign: 0 */

export const createc_train_passing = (block, generator) => ['EstacionDeRetiro_SensorVia()', generator.ORDER_ATOMIC];

export const createc_logic_compare_train = (block, generator) => {
  const state = block.getFieldValue('STATE') || '';
  const order = generator.ORDER_RELATIONAL;
  const argument0 = generator.valueToCode(block, 'A', order) || '';
  return [`${argument0} == ${state}`, order];
};

export const createc_retiro_barriers = (block) => {
  const estado = block.getFieldValue('STAT');
  return `EstacionDeRetiro_BarrerasCruce(${estado});\n`;
};

// Diverge del legacy a propósito: este usaba por error la key 'createc_luces_dique3'
// (de createcMadero); acá la key es propia.
export const createc_retiro_blinking_lights = (block, generator) => {
  const estado = block.getFieldValue('STAT');
  generator.loop_footer_.createc_retiro_blinking_lights = '\n  EstacionDeRetiro_checkLucesCruce();\n';
  return `EstacionDeRetiro_LucesIntermitentesCruceTren(${estado});\n`;
};

export const createc_retiro_luminaria_zona2 = (block) => {
  const estado = block.getFieldValue('STAT');
  return `EstacionDeRetiro_LuminariaCalle(${estado});\n`;
};

// Diverge del legacy a propósito: el firmware espera milisegundos y el legacy
// pasaba los segundos crudos; de ahí el * 1000.
export const createc_retiro_train_frequency = (block, generator) => {
  const train = block.getFieldValue('TRAIN');
  const seconds = parseInt(generator.valueToCode(block, 'TIMES', generator.ORDER_NONE), 10) * 1000;
  return train === 'sanmartin'
    ? `EstacionDeRetiro_FrecuenciaServicioFerrocarrilSanMartin(${seconds});\n`
    : `EstacionDeRetiro_FrecuenciaServicioFerrocarrilMitre(${seconds});\n`;
};

export const createc_retiro_train_service = (block) => {
  const train = block.getFieldValue('TRAIN');
  const estado = block.getFieldValue('STAT');

  let estadoTrain = train === 'sanmartin' ? 'Comando_TrenSanMartin_IniciarServicio' : 'Comando_TrenMitre_IniciarServicio';
  if (estado === 'OFF') {
    estadoTrain = train === 'sanmartin' ? 'Comando_TrenSanMartin_FinalizarServicio' : 'Comando_TrenMitre_FinalizarServicio';
  }

  return train === 'sanmartin'
    ? `EstacionDeRetiro_ServicioFerrocarrilSanMartin(${estadoTrain});\n`
    : `EstacionDeRetiro_ServicioFerrocarrilMitre(${estadoTrain});\n`;
};
